(function () {
  var MOBILE = 750;

  function stripTableWidths(table) {
    table.removeAttribute('width');
    table.style.width = '';
    table.style.minWidth = '';
    table.querySelectorAll('th, td, col').forEach(function (el) {
      el.removeAttribute('width');
      el.style.width = '';
      el.style.minWidth = '';
    });
    table.querySelectorAll('colgroup').forEach(function (group) {
      group.remove();
    });
  }

  function getContainers() {
    return document.querySelectorAll(
      '.product__description, .product__full-details, .accordion__content.rte'
    );
  }

  function ensureWrap(table) {
    var existing = table.closest('.size-chart-fit');
    if (existing) return existing;

    var wrap = document.createElement('div');
    wrap.className = 'size-chart-fit';
    var inner = document.createElement('div');
    inner.className = 'size-chart-fit__inner';
    table.parentNode.insertBefore(wrap, table);
    inner.appendChild(table);
    wrap.appendChild(inner);
    return wrap;
  }

  function fitTable(table) {
    var wrap = ensureWrap(table);
    var inner = wrap.querySelector('.size-chart-fit__inner');
    if (!inner) return;

    stripTableWidths(table);
    wrap.style.cssText = '';
    inner.style.cssText = '';
    table.style.cssText = '';

    if (window.innerWidth >= MOBILE) return;

    table.style.width = 'max-content';
    table.style.tableLayout = 'auto';
  }

  function processContainer(container) {
    if (container.hidden) return;

    container.querySelectorAll('h1,h2,h3,h4,p').forEach(function (el) {
      var text = el.textContent.trim().toLowerCase();
      if (text.indexOf('size chart') !== -1 || text.indexOf('measurements are in') !== -1) {
        el.style.textAlign = 'center';
      }
    });

    container.querySelectorAll('table').forEach(fitTable);
  }

  function init() {
    getContainers().forEach(processContainer);
  }

  function schedule() {
    init();
    requestAnimationFrame(init);
    setTimeout(init, 100);
    setTimeout(init, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', init);
  window.addEventListener('resize', init);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', init);
  }

  document.querySelectorAll('.product__view-details-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;

      if (!expanded) {
        schedule();
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('.product__accordion details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) schedule();
    });
  });
})();
